import { isNull } from './isNull'
import { not } from './not'

export const isNotNull = not(isNull)
